import { render, staticRenderFns } from "./Short_form_tea.vue?vue&type=template&id=d7febff0&scoped=true&"
import script from "./Short_form_tea.vue?vue&type=script&lang=js&"
export * from "./Short_form_tea.vue?vue&type=script&lang=js&"
import style0 from "./Short_form_tea.vue?vue&type=style&index=0&id=d7febff0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7febff0",
  null
  
)

export default component.exports